export default __webpack_public_path__ + "static/media/searchIcon.aca38c8f.svg";